const ordinal = (year: number) => {
  if (year % 10 === 1 && year % 100 !== 11) return `${year}st`
  if (year % 10 === 2 && year % 100 !== 12) return `${year}nd`
  if (year % 10 === 3 && year % 100 !== 13) return `${year}rd`
  return `${year}th`
}

/** Display only. Values stay 1st–12th so the backend mapping is unchanged. */
const IRISH_LEVEL_LABELS = [
  "1st Class (Primary)",
  "2nd Class (Primary)",
  "3rd Class (Primary)",
  "4th Class (Primary)",
  "5th Class (Primary)",
  "6th Class (Primary)",
  "1st Year (Secondary)",
  "2nd Year (Secondary)",
  "3rd Year (Secondary)",
  "4th Year / Transition Year",
  "5th Year (Secondary)",
  "6th Year (Secondary)",
]

/** Value is Indian class year (1st–12th). Label is the Irish equivalent. */
export const GRADE_LEVEL_OPTIONS = IRISH_LEVEL_LABELS.map((label, i) => ({
  value: ordinal(i + 1),
  label,
}))

export const canonicalGradeLevel = (value?: string | null): string => {
  const match = String(value || "").match(/(\d{1,2})/)
  if (!match) return ""
  const year = Number(match[1])
  if (year < 1 || year > 12) return ""
  return GRADE_LEVEL_OPTIONS[year - 1]?.value || ""
}
